import { Guid } from "guid-typescript";
import { IMessage } from "../../IMessage";

//Generated code, do not modify

export class GetEventQuery implements IMessage {
    id!: Guid;

    public constructor(init?: Partial<GetEventQuery>) {
        Object.assign(this, init);
    }

    getMethod = () => "GET";

    getUrl = () => `/admin/events/${this.id.toString()}`;

    getQueryString = () => undefined;

    getBody = () => undefined;
}